export default __webpack_public_path__ + "images/pdf_heart_3ba5738781718c2c7c26c8b1fba51411.png";